import * as React from 'react';
import ElasticsearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import classnames from 'classnames';
import { StandardLayout, CompactLayout, HorizontalLayout } from './layouts';
import { Config, connectorConfig, DISPLAY_OPTION_DEFAULTS } from '../helper';

export default function FacetedSearchOpenSearchView(props) {
  const {config, trackUrlState = true} = props;
  const {displayOptions, indexes, ViewMode, aggregation} = config;
  const {
    layout,
    showFacetsCount,
    stickyNavigation,
    hideCategoryLabel,
    showSearchBox,
    searchFields,
  } = {...DISPLAY_OPTION_DEFAULTS, ...displayOptions};
  const {viewMode} = ViewMode || {};

  const connector = React.useMemo(() => {
    const host = `${location.protocol}//${location.host}`;
    return new ElasticsearchAPIConnector(
      connectorConfig(host, indexes, aggregation, searchFields)
    );
  }, [indexes, aggregation, searchFields]);

  const css = {
    root: classnames({
        ['nv-open-search']: true,
        [`nv-open-search--${layout}-layout`]: true,
        // The view-mode value is interpolated straight into a class name; the matching
        // selectors live in the related search-results SCSS partials. Renaming a
        // Config.ViewModes value must update those styles too.
        [`nv-open-search--${viewMode}-view-mode`]: true,
        [`nv-open-search--with-facets-counters`]: !!showFacetsCount,
        [`nv-open-search--with-sticky-navigation`]: !!stickyNavigation,
        [`nv-open-search--with-no-category-label`]: !!hideCategoryLabel,
      }
    ),
  }

  // `showSearchBox` is passed as a prop (not toggled via a root CSS class like the
  // flags above) because the search box must be conditionally *rendered*. It applies to
  // the standard and horizontal layouts; compact has no search box by design. The default
  // comes from DISPLAY_OPTION_DEFAULTS (resolved once above); layouts just consume the prop.
  if (layout === Config.Layouts.Compact) {
    return <CompactLayout connector={connector} compactMode={config?.compactMode} config={config} css={css} trackUrlState={trackUrlState}/>
  }

  if (layout === Config.Layouts.Horizontal) {
    return <HorizontalLayout connector={connector} config={config} css={css} trackUrlState={trackUrlState} showSearchBox={showSearchBox}/>
  }

  return <StandardLayout connector={connector} config={config} css={css} trackUrlState={trackUrlState} showSearchBox={showSearchBox}/>;
}
